import { FC } from 'react';

export const SuccessQuestionnaireSubmittedImage: FC = () => {
  return (
    <svg
      width="96"
      height="96"
      style={{ width: '120px', height: '120px' }}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5238_38886)">
        <path
          d="M96 47.9999C96 61.4173 90.5089 73.5117 81.7041 82.2046C73.0891 90.8032 61.1601 96 48.0002 96C34.9351 96 23.006 90.7087 14.2959 82.2046C5.49115 73.5117 0 61.4173 0 47.9999C0 21.4488 21.4912 0 48.0002 0C74.5088 0 96 21.5433 96 47.9999Z"
          fill="#136DF4"
          fillOpacity="0.07"
        />
        <g opacity="0.1" filter="url(#filter0_f_5238_38886)">
          <path
            d="M76 22V68.6667C68.8424 75.2506 58.9324 78 47.9998 78C37.146 78 27.2359 74.8759 20 68.3643L20 22H76Z"
            fill="#2E4665"
          />
        </g>
        <path
          d="M76 24C78.2091 24 80 25.7909 80 28V84C71.8199 92.4651 60.4941 96 47.9998 96C35.5954 96 24.2696 91.9834 16 83.6113L16 28C16 25.7909 17.7909 24 20 24H76Z"
          fill="white"
        />
        <path
          d="M46.9449 54.1838C47.6874 53.4467 48.0586 53.0782 48.2116 52.6583C48.3727 52.2161 48.3727 51.7312 48.2116 51.289C48.0586 50.8691 47.6873 50.5006 46.9448 49.7634L38.3677 41.2485C37.6348 40.521 37.2684 40.1573 36.8521 40.0071C36.4135 39.8489 35.9335 39.8489 35.4949 40.0071C35.0786 40.1573 34.7122 40.521 33.9793 41.2485C33.2368 41.9856 32.8656 42.3542 32.7126 42.7741C32.5515 43.2163 32.5515 43.7012 32.7126 44.1434C32.8655 44.5632 33.2368 44.9318 33.9793 45.6689L42.5565 54.1839C43.2893 54.9114 43.6557 55.2751 44.0721 55.4253C44.5107 55.5835 44.9907 55.5835 45.4293 55.4253C45.8456 55.2751 46.212 54.9114 46.9449 54.1838Z"
          fill="#09C146"
        />
        <path
          d="M62.0264 34.8345C61.2936 34.107 60.9272 33.7433 60.5109 33.5931C60.0723 33.4349 59.5922 33.4349 59.1537 33.5931C58.7373 33.7433 58.3709 34.107 57.6381 34.8345L42.661 49.7028C41.9184 50.44 41.5472 50.8085 41.3942 51.2284C41.2331 51.6706 41.2331 52.1555 41.3942 52.5977C41.5472 53.0176 41.9184 53.3861 42.661 54.1233C43.3938 54.8508 43.7602 55.2146 44.1766 55.3647C44.6151 55.5229 45.0952 55.5229 45.5337 55.3647C45.9501 55.2146 46.3165 54.8508 47.0493 54.1233L62.0264 39.2549C62.7689 38.5178 63.1402 38.1493 63.2931 37.7294C63.4543 37.2872 63.4543 36.8023 63.2931 36.3601C63.1402 35.9402 62.7689 35.5717 62.0264 34.8345Z"
          fill="#09C146"
        />
        <path
          d="M64.7553 66.3737C64.7553 65.197 63.8014 64.2432 62.6248 64.2432H32.9215C31.7449 64.2432 30.791 65.197 30.791 66.3737C30.791 67.5503 31.7449 68.5042 32.9215 68.5042H62.6248C63.8014 68.5042 64.7553 67.5503 64.7553 66.3737Z"
          fill="#242529"
          fillOpacity="0.09"
        />
        <path
          d="M64.7553 75.7291C64.7553 74.5525 63.8014 73.5986 62.6248 73.5986H32.9215C31.7449 73.5986 30.791 74.5525 30.791 75.7291C30.791 76.9058 31.7449 77.8597 32.9215 77.8597H62.6248C63.8014 77.8597 64.7553 76.9058 64.7553 75.7291Z"
          fill="#242529"
          fillOpacity="0.09"
        />
        <path
          d="M56.8056 85.1774C56.8056 84.0007 55.8517 83.0469 54.675 83.0469H41.5807C40.4041 83.0469 39.4502 84.0007 39.4502 85.1774C39.4502 86.354 40.4041 87.3079 41.5807 87.3079H54.675C55.8517 87.3079 56.8056 86.354 56.8056 85.1774Z"
          fill="#242529"
          fillOpacity="0.09"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_5238_38886"
          x="8"
          y="10"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6"
            result="effect1_foregroundBlur_5238_38886"
          />
        </filter>
        <clipPath id="clip0_5238_38886">
          <rect width="96" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
